import { BsFiletypeHtml, BsFiletypeCss, BsBootstrap } from "react-icons/bs";
import { FaNodeJs } from "react-icons/fa";
import { TbBrandNextjs, TbBrandVscode } from "react-icons/tb";
import {
  SiJavascript,
  SiMui,
  SiReact,
  SiTailwindcss,
  SiMongodb,
  SiMysql,
  SiGithub,
  SiExpress,
} from "react-icons/si";

export const TechstackList = [
  {
    _id: 1,
    name: "HTML",
    icon: BsFiletypeHtml,
  },
  {
    _id: 2,
    name: "CSS",
    icon: BsFiletypeCss,
  },
  {
    _id: 3,
    name: "Bootstrap",
    icon: BsBootstrap,
  },
  {
    _id: 4,
    name: "Javascript",
    icon: SiJavascript,
  },
  {
    _id: 5,
    name: "VS Code",
    icon: TbBrandVscode,
  },

  {
    _id: 6,
    name: "React JS",
    icon: SiReact,
  },
  {
    _id: 7,
    name: "Next Js",
    icon: TbBrandNextjs,
  },
  {
    _id: 8,
    name: "React MUI",
    icon: SiMui,
  },
  {
    _id: 9,
    name: "Tailwind ",
    icon: SiTailwindcss,
  },

  {
    _id: 10,
    name: "Node JS ",
    icon: FaNodeJs,
  },
  {
    _id: 11,
    name: "Express JS ",
    icon: SiExpress,
  },

  {
    _id: 12,
    name: "Mongodb ",
    icon: SiMongodb,
  },
  {
    _id: 13,
    name: "MySQL ",
    icon: SiMysql,
  },

  {
    _id: 14,
    name: "Git / Github ",
    icon: SiGithub,
  },
];
